<template>
  <v-card id="winners">
    <v-card-title>
      Prize winners
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="prizeHeaders"
        :items="winners"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PrizeWinners',
  props: {
    winners: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    prizeHeaders() {
      return [
        { text: 'Person', value: 'name' },
        { text: 'Email Address', value: 'email' },
        { text: 'Prize', value: 'prize' },
      ];
    },
  },
};
</script>
